export default __webpack_public_path__ + "static/media/logo-gold.4c172276.png";